import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import Cookies from 'js-cookie';

import { useAppDispatch, useAppSelector } from '@/Hooks/useAppRedux';

import { setIsLoggedIn, setLoginError, setUserData } from '@/Redux/slices/AccountSlice';

import { postUserLoginAPI } from '@/Axios/api/account';
import { addAxiosToken } from '@/Axios/index';

import LoadingComponent from '@/Components/Loading';

import { storedCodeDecrypt } from '@/Utils/account';

let isFirstInit = true;

const PrivateRoute = ({ needAuth = true, component: Component, children, ...rest }: any) => {
  const dispatch = useAppDispatch();
  const { isLoggedIn } = useAppSelector((state) => state.account);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isPass, setIsPass] = useState<boolean>(false);
  const [isRedirectToHome, setIsRedirectToHome] = useState<boolean>(false);

  let isLogInSuccess = false;

  useEffect(() => {
    (async () => {
      const accessToken: string = Cookies.get('accessToken') || '';
      const ac: string = Cookies.get('ac') || '';
      const pd: string = Cookies.get('pd') || '';
      const hasAuthData = !!(accessToken !== '' && ac !== '' && pd !== '');

      if (isFirstInit) {
        if (hasAuthData) {
          try {
            const response = await postUserLoginAPI({
              grant_type: 'password',
              username: storedCodeDecrypt(ac),
              password: storedCodeDecrypt(pd),
            });

            const newAccessToken: string = response.data.access_token;
            const { username = '' } = response.data.principal;

            Cookies.set('accessToken', newAccessToken);
            addAxiosToken(newAccessToken);

            dispatch(setUserData({ username }));
            dispatch(setIsLoggedIn(true));
            isLogInSuccess = true;

            if (rest.path === '/login') {
              setIsRedirectToHome(true);
            }
          } catch (error) {
            console.error(error);
            Cookies.remove('accessToken');
            isLogInSuccess = false;
            setIsPass(false);
          }
        }

        isFirstInit = false;
      }

      if (needAuth) {
        setIsPass(isLoggedIn ? true : isLogInSuccess);
      } else {
        setIsPass(true);
      }

      setIsLoading(false);
    })();
  }, []);

  if (isLoading) {
    return (
      <>
        <Component {...rest}>{children}</Component>
        <LoadingComponent hasBackground={isFirstInit} />
      </>
    );
  }

  if (isRedirectToHome) {
    return <Navigate to="/" replace />;
  }

  if (isPass) {
    return <Component {...rest}>{children}</Component>;
  }

  dispatch(setLoginError(false));
  window.location.href = '/login';
};

export default PrivateRoute;
